<template>
  <div class="info-slot-container" :class="{ 'bg-white-custom': data.device_type === 'alarm_bridge_dmp' }">
    <template v-if="!data.isConfig">
      <dmp-devices
        v-if="data.device_type === 'alarm_bridge_dmp'"
        :panel-id="data.id"
        source="grid"
        :key="`dmp-${data.device_proxy_id}`"
      />

      <intelbras-devices
        v-if="data.device_type === 'alarm_bridge_intelbras'"
        :panel-id="data.id"
        source="grid"
        :key="`intelbras-${data.device_proxy_id}`"
      />

      <bosch-devices
        v-if="data.device_type === 'alarm_bridge_bosch'"
        :panel-id="data.id"
        source="grid"
        :key="`bosch-${data.device_proxy_id}`"
      />
    </template>

    <template v-if="data.isConfig">
      <dmp-panels-config
        v-if="data.device_type === 'alarm_bridge_dmp'"
        :panel-id="data.id"
        source="grid"
      />
    </template>
  </div>
</template>

<script>
import DmpDevices from "@/views/dmp/dmp_panels/Devices.vue";
import IntelbrasDevices from "@/views/intelbras/intelbras_panels/Devices.vue";
import BoschDevices from "@/views/bosch/bosch_panels/devices/Index.vue";
import DmpPanelsConfig from "@/views/dmp/dmp_panels/config/Index.vue";

export default {
  name: "AlarmBridgePanelSlot",
  components: {
    DmpPanelsConfig,
    DmpDevices,
    IntelbrasDevices,
    BoschDevices,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.bg-white-custom {
  background-color: #ffffff;
}
.dark-layout .bg-white-custom {
  background-color: var(--third-dark);
}

.info-slot-container {
  max-height: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
}

.sticky-card {
  position: sticky;
  top: 6rem;
  height: 80vh;
  overflow: auto;
}

.spinner {
  margin-top: calc(50% - 100px);
  margin-left: 50%;
}

.showScroll {
  position: sticky;
  top: 6rem;
  height: auto;
  overflow: hidden;
}
</style>
